import React from 'react';

const Footer = ({ isPro }) => {
    return (
        <footer className="max-w-6xl mx-auto px-6 mt-12 mb-8 text-center">
            <div className="p-6 bg-white rounded-xl shadow-md border border-gray-100">
                <p className="text-sm text-gray-600">
                    {isPro ? "Grazie per utilizzare la versione PRO!" : "Vuoi sbloccare la versione PRO?"}
                    {!isPro && (
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                const user = 'simbus82';
                                const domain = 'gmail.com';
                                window.location.href = `mailto:${user}@${domain}`;
                            }}
                            className="ml-2 text-blue-600 hover:text-blue-800 font-semibold underline underline-offset-4"
                        >
                            Richiedi codice attivazione
                        </a>
                    )}
                </p>
            </div>
        </footer>
    );
};

export default Footer;
